import { axios } from '../plugins/http-axios';
import { Module } from 'vuex';
import { RootState } from '@/store/index';
import {
  IFilterIndividualRequestsSettings,
  IFilterSettingsForm,
  IUser,
  IOfficeUser,
  ISelectRole,
  IMenu,
  IAppBlock,
  IPrivileges,
  IRole,
  IUserState,
} from '@/interfaces/User';
function sortMenu(menu: IMenu[]): IMenu[] {
  const lku = menu.find((item) => item.url === '/admin');
  const lkb = menu.find((item) => item.url === '/bank');
  return <IMenu[]>[lku, lkb].filter((item) => {
    return !!item;
  });
}

const user: IUser = {
  id: '',
  username: '',
  fio: '',
  firstName: '',
  lastName: '',
  parName: '',
  domainName: '',
  employee: {
    id: '',
    userid: '',
    name: '',
    parname: '',
    numberDocument: '',
    nameEmployee: '',
    email: '',
    deleted: false,
    revokeFromApplication: false,
    fio: '',
  },
  email: '',
  firstPassword: false,
  roles: [],
  offices: [],
  activeRole: {
    id: 0,
    name: '',
    active: false,
    menuTree: [],
    menuFlat: [],
    clientBlocks: [],
    applicationBlocks: [],
    privileges: [],
  },
  //@ts-ignore
  filterSettings: {},
  schemaDesign: '',
  allSignTypes: [],
  signType: '',
};

const templateFilterIndividualRequest: IFilterIndividualRequestsSettings = {
  statuses: [],
  agents: [],
  dateFrom: '',
  dateTo: '',
  changeDateFrom: '',
  changeDateTo: '',
  page: 0,
  limit: 10,
  substring: '',
  sorted: {
    field: 'number',
    orderBy: 'ASC',
  },
};

const templateFilterForm: IFilterSettingsForm = {
  offset: 0,
  limit: 10,
  substring: '',
  sorted: {
    field: '',
    orderBy: '',
  },
  requestId: '',
};

export default <Module<IUserState, RootState>>{
  state: {
    filterForm: JSON.parse(JSON.stringify(templateFilterForm)),
    user: JSON.parse(JSON.stringify(user)),
    authorized: undefined
  },
  mutations: {
    setActiveRole(state, role: IRole) {
      role.menuTree = sortMenu(role.menuTree);
      state.user.activeRole = role;
    },
    setAuthorized(state, value) {
      state.authorized = value;
    },
    setUser(state, data: IUser = user) {
      if (data.activeRole && data.activeRole.menuTree) data.activeRole.menuTree = sortMenu(data.activeRole.menuTree);

      for (const key in user) {
        //@ts-ignore
        state.user[key] = data[key] || user[key];
        state.user.allSignTypes = data['allSignTypes'];
      }
    },
    /*setMenu(state, menu = []) {
            state.user.activeRole.menuTree = menu;
        },*/
    _setFilterApplication(state, filter) {
      if (!('application' in state.user.filterSettings))
        state.user.filterSettings = Object.assign({}, state.user.filterSettings, { application: {} });

      if (!filter) {
        state.user.filterSettings.application = JSON.parse(JSON.stringify(templateFilterIndividualRequest));
      } else if (state.user.filterSettings.application) {
        for (const key in templateFilterIndividualRequest) {
          if (key in state.user.filterSettings.application) {
            if (key in filter) {
              state.user.filterSettings.application[key] = filter[key];
            }
          } else {
            state.user.filterSettings.application[key] = filter[key] || templateFilterIndividualRequest[key];
          }
        }
      }
    },
  },
  actions: {
    async getUser({ commit, dispatch, getters, rootGetters }): Promise<string> {
      return axios
        .get<IUser>(rootGetters.uri.userInfo)
        .then((resp) => {
          commit('setAuthorized', 'authorized');
          commit('setUser', resp.data);

          if (!getters.role || !getters.role.id) commit('setAccessRole');

          return 'authorized';
        })
        .catch((e) => {
          if ('response' in e && e.response instanceof Object) {
            if (e.response.status == 401) {
              commit('setAuthorized', 'no_authorized');
              return Promise.resolve('no_authorized');
            }
            if (e.response.status == 423) {
              //todo убрать пробел
              if (e.response.data.errorMessage === 'Role block ') {
                commit('setAuthorized', 'authorized');
                return Promise.resolve('authorized');
              } else {
                commit('setAuthorized', 'blocked');
                return Promise.resolve('blocked');
              }
            }
          }

          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    setActiveRole({ commit, getters, dispatch, rootGetters }, data) {
      commit('setActiveRole', data);

      axios
        .post(rootGetters.uri.changeRole, { id: data.id })
        .then((resp) => {
          console.log(resp.data);
        })
        .catch((e) => {
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
  },
  getters: {
    user: (state): IUser => state.user,
    isFirstPassword: (state): boolean => state.user.firstPassword,
    authorized: (state): string | undefined => state.authorized,
    getFilterApplication: (state): IFilterIndividualRequestsSettings => {
      if (state.user.filterSettings && state.user.filterSettings.application) {
        return state.user.filterSettings.application;
      } else {
        return JSON.parse(JSON.stringify(templateFilterIndividualRequest));
      }
    },
    role: (state): IRole => state.user.activeRole,
    listRoles: (state): ISelectRole[] => state.user.roles.map((item) => ({ text: item.name, value: item })),
    privileges: (state, getters): IPrivileges => getters.role.privileges,
    isPrivileges:
      (state, getters) =>
      (name: string): boolean =>
        !!getters.privileges.find((priv: IPrivileges) => priv.name === name),
    isShowBlock: (state, getters) => (name: string) =>
      getters.role.applicationBlocks.find((block: IAppBlock) => block.code.toLowerCase() === name.toLowerCase()),
    blocks: (state, getters): IAppBlock[] => getters.role.applicationBlocks,
    getStorageNavbarBlocks:
      (state, { blocks }) =>
      (status: string) => {
        if (status === 'Загрузка документов') {
          return blocks as IAppBlock[];
        }
        return blocks.filter((block: IAppBlock) => block.code !== 'FIELD_UPLOAD') as IAppBlock[];
      },
    menu: (state, getters): IMenu[] => getters.role.menuTree,
    menuFlat: (state, getters): IMenu[] => getters.role.menuFlat,
    checkRoute:
      (state, getters) =>
      (route: string): boolean =>
        !!getters.menuFlat.find((item: IMenu) => item.url === route),
    offices: (state): IOfficeUser[] => state.user.offices,
    filterForm: (state): IFilterSettingsForm => state.filterForm,
  },
};
